import React,{useState} from 'react';
import {HashRouter as Router,Routes,Route,Link,Navigate} from 'react-router-dom';
import RegistrationForm from './components/RegistrationForm';
import ParticipantsList from './components/ParticipantsList';
import SafeIcon from './common/SafeIcon';
import {FiShield,FiLock,FiArrowLeft} from 'react-icons/fi';

// جلب كافة المتغيرات من ملف البيئة المحمي 
const PUBLIC_TOKEN=import.meta.env.VITE_PUBLIC_TOKEN;
const ADMIN_PASSWORD=import.meta.env.VITE_ADMIN_PASSWORD;
const LOGO_URL=import.meta.env.VITE_LOGO_URL;
const BG_URL=import.meta.env.VITE_BG_URL;

const AdminLogin=({onLogin})=> {
const [password,setPassword]=useState('');
const [error,setError]=useState('');
const handleSubmit=(e)=> {
e.preventDefault();
if (password===ADMIN_PASSWORD) {
onLogin();
} else {
setError('كلمة المرور غير صحيحة');
}};
return ( 
<div className="max-w-md w-full px-4"> 
<div className="text-center mb-8"> 
<div className="inline-flex items-center justify-center mb-6"> 
<img src={LOGO_URL} alt="Logo" className="h-24 w-auto object-contain" /> 
</div> 
<h1 className="text-2xl font-bold text-slate-800">منطقة المشرف</h1> 
<p className="text-slate-600">يرجى إدخال كلمة المرور للوصول للوحة التحكم</p> 
</div> 
<div className="bg-white/95 backdrop-blur-sm p-8 rounded-3xl shadow-xl border border-white/20"> 
<form onSubmit={handleSubmit} className="space-y-6"> 
<div> 
<label className="block text-sm font-bold text-slate-700 mb-2">كلمة المرور</label> 
<input type="password" required value={password} onChange={(e)=> setPassword(e.target.value)} className="w-full px-4 py-4 border border-slate-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#9f8574] transition-all bg-white text-center text-lg" placeholder="••••••••" /> 
</div> 
{error && ( 
<div className="text-red-500 text-sm font-bold text-center bg-red-50 py-2 rounded-lg border border-red-100"> 
{error} 
</div> 
)} 
<button type="submit" style={{backgroundColor: '#9f8574'}} className="w-full py-4 hover:opacity-90 text-white rounded-2xl font-bold text-lg transition-all shadow-lg active:scale-95" > 
دخول المشرف 
</button> 
</form> 
<Link to="/" className="mt-6 flex items-center justify-center gap-2 text-slate-500 hover:text-[#9f8574] transition-colors text-sm font-semibold"> 
<SafeIcon icon={FiArrowLeft} /> العودة للرئيسية 
</Link> 
</div> 
</div> 
);};

const PublicRegistration=()=> {
const [isRegistered,setIsRegistered]=React.useState(false);
return ( 
<div className="max-w-md w-full"> 
<div className="text-center mb-10"> 
<div className="inline-flex items-center justify-center mb-6"> 
<img src={LOGO_URL} alt="Logo" className="h-28 w-auto object-contain drop-shadow-sm" /> 
</div> 
<h1 className="text-3xl font-bold text-slate-800 mb-2">تأكيد الحضور</h1> 
<p className="text-slate-700 font-medium">يرجى إدخال بياناتك لتأكيد حضورك "ديوانية نجيب" بإذن الله</p> 
</div> 
<div className="transition-all duration-500 transform"> 
{isRegistered ? ( 
<div className="bg-white/95 backdrop-blur-sm p-10 rounded-3xl shadow-sm border border-white/20 text-center"> 
<div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6"> 
<SafeIcon icon={FiShield} className="text-4xl" /> 
</div> 
<h2 className="text-2xl font-bold text-slate-800 mb-2">شكراً لك!</h2> 
<p className="text-slate-600">تم تسجيل بياناتك بنجاح. نتطلع لرؤيتك في "ديوانية نجيب" بإذن الله.</p> 
<button onClick={()=> setIsRegistered(false)} className="mt-8 text-[#9f8574] font-semibold hover:underline" > 
تسجيل مشارك آخر 
</button> 
</div> 
) : ( 
<RegistrationForm token={PUBLIC_TOKEN} onSuccess={()=> setIsRegistered(true)} /> 
)} 
</div> 
</div> 
);};

const AdminDashboard=()=> {
const [isAuthenticated,setIsAuthenticated]=useState(false);
if (!isAuthenticated) {
return <AdminLogin onLogin={()=> setIsAuthenticated(true)} />;
} 
return ( 
<div className="max-w-5xl w-full px-4"> 
<div className="flex flex-col sm:flex-row items-center justify-between mb-8 gap-4 bg-white/80 backdrop-blur-md p-6 rounded-3xl border border-white/20 shadow-sm"> 
<div className="flex items-center gap-4"> 
<img src={LOGO_URL} alt="Logo" className="h-12 w-auto" /> 
<div className="h-8 w-[1px] bg-slate-200 hidden sm:block"></div> 
<div> 
<h1 className="text-xl font-bold text-slate-800">لوحة التحكم</h1> 
<p className="text-slate-500 text-xs">متابعة المسجلين في الفعالية</p> 
</div> 
</div> 
<div className="flex gap-3"> 
<button onClick={()=> setIsAuthenticated(false)} className="text-sm font-semibold text-red-600 bg-red-50 px-4 py-2 rounded-xl hover:bg-red-100 transition-colors" > 
تسجيل خروج 
</button> 
<Link to="/" className="text-sm font-semibold text-[#9f8574] bg-[#9f8574]/10 px-4 py-2 rounded-xl hover:bg-[#9f8574]/20 transition-colors" > 
الرئيسية 
</Link> 
</div> 
</div> 
<ParticipantsList token={PUBLIC_TOKEN} /> 
</div> 
);};

function App() {
return ( 
<Router> 
<div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center bg-cover bg-center bg-no-repeat bg-fixed relative" style={{backgroundImage: `url(${BG_URL})`}}> 
<div className="absolute inset-0 bg-slate-50/40 pointer-events-none"></div> 
<div className="relative z-10 w-full flex flex-col items-center"> 
<Routes> 
<Route path="/" element={<PublicRegistration />} /> 
<Route path="/admin26" element={<AdminDashboard />} /> 
<Route path="*" element={<Navigate to="/" />} /> 
</Routes> 
<div className="mt-12 text-center"> 
<p className="text-slate-600 text-sm font-bold bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20"> 
© {new Date().getFullYear()} جميع الحقوق محفوظة 
</p> 
</div> 
</div> 
</div> 
</Router> 
);
}
export default App;